import create from 'zustand';

import id from '../utils/id';

const useToast = create((set, get) => ({
	toasts: [],
	show: (message, { type = 'success' } = {}) => {
		const toast = { id: id(), message, type, visible: true };

		set(({ toasts }) => ({
			toasts: [...toasts, toast],
		}));

		setTimeout(() => {
			get().close(toast.id);
		}, 5000);
	},
	close: (toastId) => {
		set(({ toasts }) => ({
			toasts: toasts.map((toast) => {
				if (toast.id === toastId) {
					return { ...toast, visible: false };
				}

				return toast;
			}),
		}));
	},
	cleanup: () => {
		set(({ toasts }) => toasts.filter((toast) => toast.visible));
	},
}));

export default useToast;
